module.exports = __webpack_public_path__ + "static/media/zoom.ee1a0a3b.svg";